import { DefaultTheme } from '../theme';

export const CSS = {
	item: 'c-Menu__Item',
	hidden: 'c-Menu__Item--Hidden',
	disabled: 'c-Menu__Item--Disabled',
	selected: 'c-Menu__Item--Selected',
};

export const Style = {
	[CSS.item]: {
		color: DefaultTheme.font.color.supporting,
		'font-family': DefaultTheme.font.family,
		'font-size': DefaultTheme.font.size,
		'line-height': DefaultTheme.space(8),
		display: 'flex',
		'align-items': 'center',
		padding: DefaultTheme.space(2) + ' ' + DefaultTheme.space(3),
		cursor: 'pointer',
		'& i': {
			'margin-right': DefaultTheme.space(4),
		},
		'&:active': {
			'background-color': DefaultTheme.background.mediumGrey,
		},
		'&:focus': {
			'background-color': DefaultTheme.background.lightGrey,
		},
	},
	[`${CSS.item}.${CSS.disabled}`]: {
		cursor: 'default',
		color: DefaultTheme.font.color.disabled,
		'&:hover': {
			'background-color': DefaultTheme.background.lightGrey,
		},
		'&:active': {
			'background-color': DefaultTheme.background.grey,
		},
	},
	[`${CSS.item}.${CSS.selected}`]: {
		'background-color': DefaultTheme.background.lightGrey,
	},
	[`${CSS.item}.${CSS.selected}.${CSS.disabled}`]: {
		color: DefaultTheme.font.color.disabled,
	},
	[CSS.hidden]: {
		display: 'none',
	},
};
